<template>
  <div class="w-full h-full" v-loading="loadEngineLoading">
    <video id="clip_video" class="w-full h-full" autoplay playsinline muted></video>
  </div>
</template>

<script>
import { cloudRender as render } from 'wiz-cloud-render'

export default {
  props: {
    md5: {
      type: String,
      defalut: '',
    },
    fileId: {
      type: String,
      defalut: '',
    },
  },
  data() {
    return {
      loadEngineLoading: false,
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 云渲染协议
    cloudProtocol() {
      return this.modelSetting.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloudServerPath() {
      return this.modelSetting.cloudServerPath || '192.168.20.79:8082'
    },
    cloudRender() {
      return new render()
    },
    handoverServerConfig() {
      return _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
        .handoverServerConfig
    },
  },
  methods: {
    // 加载引擎
    async loadEngine() {
      try {
        this.loadEngineLoading = true
        const param = {
          signalServer: `${this.cloudProtocol}://${this.cloudServerPath}`,
          options: {
            openDebug: false,
            videoDom: document.getElementById('clip_video'),
          },
        }
        const { data } = await this.cloudRender.Engine.loadEngine(param)
        if (data) {
          this.loadEngineSucces = true
        }
        this.loadEngineLoading = false
        // 判断是否需要加载默认模型
        this.loadModel()
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 加载模型
    async loadModel() {
      const md5 = this.md5.toLowerCase()
      const loadModelStatus = this.cloudRender.Model.addModel([
        {
          targetUrl: `data://../apps/${this.handoverServerConfig.folderName}/models/${md5}/${md5}.pr`,
          fileUrl: `${this.handoverServerConfig.baseUrl}/api/std/file/${this.fileId}`,
          md5,
          tempPath: `data://../temps/models/${md5}/${md5}.pr`,
          options: {
            modelId: this.fileId,
            httpOptions: {
              methods: 'GET',
              header: { Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}` },
            },
          },
        },
      ])
      this.cloudRender.Dispatch.on('Model', this.loadModelConnect)
    },
    // 监听模型加载
    async loadModelConnect(res) {
      if (res && res.status && res.data.currentState === 4) {
        // 获取模型信息
        const modelInfo = await this.cloudRender.Engine.player.Native.Model.getAllInfo()
        const treeItem = modelInfo[this.fileId].treeItem
        // 移动相机视角
        this.cloudRender.Engine.player.Native.Camera.moveToItem(treeItem, 1)
      }
    },
  },
  async mounted() {
    this.loadEngine()
  },
  beforeDestroy() {
    this.cloudRender.Engine.destroyEngine()
  },
}
</script>
